/* @flow */
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const Logo = ({ link, title }) => {
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [fontSize, setFontSize] = useState(60)
  useEffect(() => {
    setFontSize(60 * deviceSize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceSize])
  return (
    <div>
      <Link to={link} style={{ display: 'flex', alignItems: 'center' }}>
        <span style={{ color: '#fff', fontSize: fontSize }} className="nsg-glyph--swoosh" />
        <span style={{ color: '#fff', fontWeight: 600, fontSize: '20px', marginLeft: 5 }}>{title}</span>
      </Link>
    </div>
  )
}

export default Logo
